<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.type"
        placeholder="抽奖模式"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in RAFFLE_ACTIVITY_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="jumpAddOrEdit('CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">抽奖奖品数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="商户编号"
        align="center"
        prop="mchId"
      ></el-table-column>
      <el-table-column
        label="奖品名称"
        align="center"
        prop="name"
      ></el-table-column>
      <el-table-column
        label="奖品类型"
        align="center"
        prop="typeName"
      ></el-table-column>
      <el-table-column
        label="奖品图标"
        prop="iconUrl"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.iconUrl"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="jumpAddOrEdit('UPDATE', scope.row)"
            >编辑</el-button
          >
          <el-popconfirm
            confirm-button-text="是的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            title="确定要删除该奖品吗？"
            @confirm="deletePrizes(scope.row)"
            style="margin: 0 8px;"
          >
            <el-button slot="reference" type="danger" size="mini"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getPrizesList, deleteRafflePrizes } from "@/api/raffle.js";
import { formatApiDate } from "@/utils/utils";
import { getValue, RAFFLE_ACTIVITY_TYPE } from "@/utils/enumUtile";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    RAFFLE_ACTIVITY_TYPE() {
      return RAFFLE_ACTIVITY_TYPE;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        type: null
      },
      btnLoading: false
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getPrizesList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 跳转到新增 or 编辑
     */
    jumpAddOrEdit(type, item) {
      if (type === "UPDATE") {
        this.$router.push({ path: "/raffle/prizes/edit/" + item.id });
      } else if (type === "CREATE") {
        this.$router.push({ path: "/raffle/prizes/add" });
      }
    },
    // 删除奖品
    deletePrizes(item) {
      const params = {
        id: item.id
      };
      deleteRafflePrizes(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.getList();
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
            duration: 2000
          });
        }
      });
    }
  }
};
</script>
<style scoped lang="scss"></style>
